import React from 'react'
import equipsyLogo from '../assets/HeaderLogo.svg'

const SiteHeader = () => {
  return (
    <header className="site-header">
      <div className="site-header-inner">
        <div className="site-header-brand">
          <img src={equipsyLogo} alt="Equipsy" />
          <span className="site-header-title">Custom Shower Base Insert Order</span>
        </div>
      </div>
    </header>
  )
}

export default SiteHeader
